'use strict';
var base = require('./base');
var search = require('../search/search')
var focusHelper = require('../components/focus');
var startCarousel = require('../ah-carousel');

if (!$('.cart-empty').length && !$('.cart-page').length) {
	base.selectAttribute();
	base.colorAttribute();
	base.otherAttribute();
}
base.textareaCharacterCounter();
base.updateButtonText();

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
  if ($('#quickViewModal').length !== 0) {
    $('#quickViewModal').remove();
  }
  var htmlString =
    '<!-- Modal -->' +
    '<div class="modal fade" id="quickViewModal" role="dialog" aria-label="Quick View Modal">' +
    '<span class="enter-message sr-only" ></span>' +
    '<div class="modal-dialog quick-view-dialog">' +
    '<!-- Modal content-->' +
    '<div class="modal-content">' +
    '<div class="modal-header">' +
    '    <a class="full-pdp-link" href="" tabindex="-1"></a>' +
    '    <button type="button" class="close pull-right" data-dismiss="modal">' +
    '        <span aria-hidden="true">&times;</span>' +
    '        <span class="sr-only"> </span>' +
    '    </button>' +
    '</div>' +
    '<div class="modal-body"></div>' +
    '<div class="modal-footer"></div>' +
    '</div>' +
    '</div>' +
    '</div>';
  $('body').append(htmlString);
}

/**
 * @typedef {Object} QuickViewHtml
 * @property {string} body - Main Quick View body
 * @property {string} footer - Quick View footer content
 */

/**
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from quickview template
 * @return {QuickViewHtml} - QuickView content components
 */
function parseHtml(html) {
  var $html = $('<div>').append($.parseHTML(html));

  var body = $html.find('.product-quickview');
  var footer = $html.find('.modal-footer').children();

  return {
    body: body,
    footer: footer,
  };
}

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
function fillModalElement(selectedValueUrl) {
  $('.modal-body').spinner().start();
  $.when(
    $.ajax({
      url: selectedValueUrl,
      method: 'GET',
      dataType: 'json',
      success: function (data) {
        var parsedHtml = parseHtml(data.renderedTemplate);

        $('#quickViewModal .modal-body').empty();
        $('#quickViewModal .modal-body').html(parsedHtml.body);
        $('#quickViewModal .modal-footer').html(parsedHtml.footer);
        $('#quickViewModal .full-pdp-link').text(data.quickViewFullDetailMsg);
        $('#quickViewModal .full-pdp-link').attr('href', data.productUrl);
        $('#quickViewModal .size-chart').attr('href', data.productUrl);
        $('#quickViewModal .modal-header .close .sr-only').text(
          data.closeButtonText
        );
        $('#quickViewModal .enter-message').text(data.enterDialogMessage);
        $('#quickViewModal').modal('show');
        $(
          '#quickViewModal .swatch-picker, #quickViewModal .variant-picker'
        ).selectpicker();
        changeSwatch();
        changeSwatchSelect();
        changeSizeSelect();
        closeQuickViewModal();
        setTimeout(function () {
          startCarousel.initCarouselHorizontal();
        }, 300);
        base.validateProductCustomFields();
        if (data.selectedSwatch) {
          $('.product-quickview .swatch-picker').selectpicker(
            'val',
            data.selectedSwatch
          );
        }
        data.isQuickViewResult = true;
        var $productContainer = $('#quickViewModal .product-quickview');
        base.attributeSelect(selectedValueUrl, $productContainer, data);
        yotpo.refreshWidgets();

        setTimeout(function () {
          if ($('#quickViewModal .pdp-carousel .slick-active').length > 0) {
            $('#quickViewModal .pdp-carousel').attr('aria-hidden', 'true');
            $('#quickViewModal .pdp-carousel .slick-active').attr('tabindex', '-1');
            $('#quickViewModal .pdp-carousel .slick-active').attr('aria-hidden', 'true');
          }
          search.showYotpoStarReviews();
        }, 500);

        $('#quickViewModal .pdp-carousel').on('afterChange', function (event, slick, currentSlide, nextSlide) {
          setTimeout(function () {
            $(slick.$slides.get(currentSlide)).attr('tabindex', '-1');
            $(slick.$slides.get(currentSlide)).attr('aria-hidden', 'true');
          }, 300);
        });

        $.spinner().stop();
      },
      error: function () {
        $.spinner().stop();
      },
    })
  ).then(function () {
    // init modal functions
    base.textareaCharacterCounter();
    updateAddToCart();
    updateAvailability();

    let upchargeValues = [
        { 'attribute': 'color', 'price': $('.js-variationUpchargeByColor').val() },
        { 'attribute': 'size', 'price': $('.js-variationUpchargeBySize').val() }
      ];
    var $productContainer = $('#quickViewModal .product-quickview');
    base.productUpchargeValues(upchargeValues, $productContainer);
  });
}

function changeSwatch() {
  $(document).on(
    'click',
    '.product-quickview .attribute button.color-attribute',
    function (e) {
      // once attribute selected, it can not be deselected
      if ($(this).hasClass('selected')) {
        return false;
      }
      var selected = $(this).find('.selection_swatch_color').data('attr-value');
      $('.product-quickview .attribute .selection_swatch_color').removeClass(
        'selected'
      );
      $('.product-quickview .attribute')
        .find("[data-attr-value='" + selected + "']")
        .addClass('selected');
      $('.product-quickview .swatch-picker').off('changed.bs.select');
      selected = $(this).hasClass('selected') ? '' : selected;
      $('.product-quickview .swatch-picker').selectpicker('val', selected);
      changeSwatchSelect();
    }
  );
}

function changeSwatchSelect() {
  $('.product-quickview #swatch-picker-select').on(
    'changed.bs.select',
    function (e) {
      var selected = $(e.currentTarget).val();
      if (
        $(
          '.product-quickview .attribute .selection_swatch_color.selected'
        ).data('attr-value') !== selected
      ) {
        $('.product-quickview .attribute .selection_swatch_color').removeClass(
          'selected'
        );
        $('.product-quickview .attribute')
          .find("[data-attr-value='" + selected + "']")
          .click();
      }
      if (!selected) {
        $('#quickViewModal button.add-to-cart').attr('disabled', true);
      }
    }
  );
}

function changeSizeSelect() {
  $('.product-quickview #nonswatch-select').on(
    'changed.bs.select',
    function (e) {
      var selected = $(e.currentTarget).val();

      if (
        $('.product-quickview .attribute .selection-button.selected').data(
          'attr-value'
        ) !== selected
      ) {
        $('.product-quickview .attribute .selection-button').removeClass(
          'selected'
        );
        $('.product-quickview .attribute')
          .find("[data-attr-value='" + selected + "']")
          .click();
      }

      if (!selected) {
        $('#quickViewModal button.add-to-cart').attr('disabled', true);
      }
    }
  );
}

function closeQuickViewModal() {
  $('.video-modal .js-quickview-video-close').on('click', function (e) {
    var modalId = $(this).closest('.video-modal').attr('id');
    $('#' + modalId).modal('hide');
  });
}

function updateAddToCart() {
  $('#quickViewModal').on('product:updateAddToCart', function (e, response) {
    // update global add to cart (single products, bundles)
    var dialog = $(response.$productContainer).closest('.quick-view-dialog');

    if ($('.global-availability', dialog).data('ready-to-order')) {
      $('#quickViewModal button.add-to-cart').removeAttr('disabled');
    } else {
      $('#quickViewModal button.add-to-cart').attr('disabled', true);
    }

    $('#quickViewModal .product-quickview').data('pid', response.product.id);
    $('#quickViewModal .full-pdp-link').attr(
      'href',
      response.product.selectedProductUrl
    );
    $('#quickViewModal .product-id').text(response.product.id);
  });
}

function updateAvailability() {
  $('#quickViewModal').on('product:updateAvailability', function (e, response) {
    // bundle individual products
    $('#quickViewModal .product-availability', response.$productContainer)
      .data('ready-to-order', response.product.readyToOrder)
      .data('available', response.product.available)
      .find('.availability-msg')
      .empty()
      .html(response.message);

    var dialog = $(response.$productContainer);

    if ($('#quickViewModal .product-availability').length) {
      // bundle all products
      var allAvailable = $('#quickViewModal .product-availability')
        .toArray()
        .every(function (item) {
          return $(item).data('available');
        });

      var allReady = $('#quickViewModal .product-availability')
        .toArray()
        .every(function (item) {
          return $(item).data('ready-to-order');
        });

      $('#quickViewModal .global-availability')
        .data('ready-to-order', allReady)
        .data('available', allAvailable);

      $('#quickViewModal .global-availability .availability-msg')
        .empty()
        .html(
          allReady ? response.message : response.resources.info_selectforstock
        );
    } else {
      // single product
      $('#quickViewModal .global-availability')
        .data('ready-to-order', response.product.readyToOrder)
        .data('available', response.product.available)
        .find('.availability-msg')
        .empty()
        .html(response.message);
    }
    $('div.availability', response.$productContainer)
      .data('ready-to-order', response.product.readyToOrder)
      .data('available', response.product.available);

    $('.availability-msg', response.$productContainer)
      .empty()
      .html(response.message);

    $('.js-availability-msg', response.$productContainer).attr(
      'data-inventory',
      response.product.availability.type
    );

    $('.js-availability-msg-label', response.$productContainer)
      .empty()
      .html(response.product.availability.label);

    var openModal = $('body').hasClass('modal-open');
    if (!openModal && $('.js-availability-msg-personalize').length) {
      if (
        response.product.productType != 'master' &&
        response.product.availability.messages.length > 0
      ) {
        $('.js-availability-msg-personalize').removeClass('hide');
      } else {
        $('.js-availability-msg-personalize').addClass('hide');
      }
    }
    if ($('.js-availability-msg-ordernow').length) {
      if (
        response.product.productType != 'master' &&
        response.product.availability.messages.length > 0 &&
        response.product.availability.type == 'ats'
      ) {
        $('.js-availability-msg-ordernow').removeClass('hide');
      } else {
        $('.js-availability-msg-ordernow').addClass('hide');
      }
    }

    if ($('.global-availability').length) {
      var allAvailable = $('.product-availability')
        .toArray()
        .every(function (item) {
          return $(item).data('available');
        });

      var allReady = $('.product-availability')
        .toArray()
        .every(function (item) {
          return $(item).data('ready-to-order');
        });

      $('.global-availability')
        .data('ready-to-order', allReady)
        .data('available', allAvailable);

      $('.global-availability .availability-msg')
        .empty()
        .html(
          allReady ? response.message : response.resources.info_selectforstock
        );
    }
  });
}

module.exports = {
  showQuickview: function () {
    $('body').on('click', '.quickview', function (e) {
      e.preventDefault();
      var selectedValueUrl = $(this).closest('a.quickview').attr('data-href');
      $(e.target).trigger('quickview:show');
      getModalHtmlElement();
      fillModalElement(selectedValueUrl);
    });

    //Required in case of quickview modal, as two modals opened together
    $(document).on('click', '#notifymeModal button.close', function () {
      if ($('#quickViewModal').hasClass('show')) {
        $('#notifymeModal').remove();
        $('.modal-backdrop').last().remove();
      }
    });
  },

  focusQuickview: function () {
    $('body').on('shown.bs.modal', '#quickViewModal', function () {
      $('#quickViewModal .close').focus();
    });
  },

  trapQuickviewFocus: function () {
    $('body').on('keydown', '#quickViewModal', function (e) {
      var focusParams = {
        event: e,
        containerSelector: '#quickViewModal',
        firstElementSelector: '.full-pdp-link',
        lastElementSelector: '.add-to-cart-global',
        nextToLastElementSelector: '.modal-footer .quantity-select',
      };
      focusHelper.setTabNextFocus(focusParams);
    });
  },

  availability: base.availability,
  showSpinner: function () {
    $('body').on('product:beforeAddToCart', function (e, data) {
      $(data).closest('.modal-content').spinner().start();
    });
  },

  hideDialog: function () {
    $('body').on('product:afterAddToCart', function () {
      $('#quickViewModal').modal('hide');
    });

    $('body').on('hidden.bs.modal', '#quickViewModal', function () {
      $('#quickViewModal .modal-body').empty();
    });
  },

  beforeUpdateAttribute: function () {
    $('body').on('product:beforeAttributeSelect', function () {
      $('.modal.show .modal-content').spinner().start();
    });
  },

  initQuantityUpdate: base.updateQuantity,
  addToCart: base.addToCart,
  notifyMe: base.notifyMe,
  updateAttribute: function () {
    $('body').on('product:afterAttributeSelect', function (e, response) {
      if ($('.modal.show .product-quickview>.bundle-items').length) {
        $('.modal.show')
          .find(response.container)
          .data('pid', response.data.product.id);
        $('.modal.show')
          .find(response.container)
          .find('.product-id')
          .text(response.data.product.id);
      } else if ($('.set-items').length) {
        response.container.find('.product-id').text(response.data.product.id);
      } else {
        // SKU gets updated in quickview when all variations are selected
        var $productIdElements = response.container.find('.product-id');
        if ($productIdElements.length > 1) {
          $productIdElements.each(function () {
            // update main product pid and not of co-ordinating items
            if (!$(this).parents('.coordinating-product').length) {
              $(this).text(response.data.product.id);
            }
          });
        } else {
          response.container.find('.product-id').text(response.data.product.id);
        }

        $('.modal.show .product-quickview').data(
          'pid',
          response.data.product.id
        );
        $('.modal.show .full-pdp-link').attr(
          'href',
          response.data.product.selectedProductUrl
        );
        $('.modal.show .qv-link').attr(
          'href',
          response.data.product.selectedProductUrl
        );
        $('.modal.show .product__name').attr(
          'href',
          response.data.product.selectedProductUrl
        );
      }
    });
  },

  disableVideoModal: function () {
    $('body').on('hidden.bs.modal', '.video-modal', function () {
      var srcdoc = $('#yt-player iframe').attr('srcdoc');
      $('#yt-player iframe').attr('srcdoc', '');
      $('#yt-player iframe').attr('srcdoc', srcdoc);

      if ($('#quickViewModal').is(':visible')) {
        $('body').addClass('modal-open');
        $('#quickViewModal').focus();
      }
      return false;
    });
  },

  showHoverSwatchProduct: function() {
	  var eventName = $('.swatch-circle').parents('.slick-slider').length > 0 ? 'click' : 'focus';
	  $(document).on(eventName, '.color-swatches .swatch-circle',
	        function () {
              var $swatch = $(this).children('img');
	            if (($(this).closest('.color-container').length > 0) && ($(this).closest('.product.product-detail').length > 0)) {
	                var $colorSwatchValues = $(this).closest('.product.product-detail').find('#colorSwatchData').val();
	                var colorSwatchData = $colorSwatchValues ? JSON.parse($colorSwatchValues) : null;
	                var swatchID = $(this).attr('data-attr-value');
	                var swatchImg = colorSwatchData && colorSwatchData[swatchID] ? colorSwatchData[swatchID].large : '';
	                var swatchAltImg = colorSwatchData && colorSwatchData[swatchID] ? colorSwatchData[swatchID].altImage : '';

	                if (swatchAltImg === 'null') {
	                    swatchAltImg = swatchImg;
	                }

	                if (swatchImg && swatchImg.length > 0) {
	                    var imgContainer = $(this).closest('.product').find('.image-container');

	                    imgContainer.find('.tile-image-primary img').attr('src', swatchImg);
	                    imgContainer.find('.tile-image-primary source').attr('srcset', swatchImg);

	                    if (imgContainer.find('.tile-image-alt img').length > 0) {
	                        imgContainer.find('.tile-image-alt img').attr('src', swatchAltImg);
	                        imgContainer.find('.tile-image-alt source').attr('srcset', swatchAltImg);
	                    }
	                }
	            } else {
	                var swatchImg = $swatch.attr('data-full-img');
	                var swatchAltImg = $swatch.attr('data-alt-img');
	                var swatchImgUrl = $swatch.attr('data-full-url');
	                var quickImgUrl = $swatch.attr('data-quickview-url');

	                if (swatchAltImg === 'null') {
	                    swatchAltImg = swatchImg;
	                }

	                if (swatchImg && swatchImg.length > 0 && swatchImgUrl.length > 0) {
	                    var imgContainer = $(this).closest('.product').find('.image-container');
	                    var imgLink = imgContainer.find('.image-container__link');
	                    var quickLink = imgContainer.find('.quickview');

	                    imgContainer.find('.tile-image-primary img').attr('src', swatchImg);
	                    imgContainer.find('.tile-image-primary source').attr('srcset', swatchImg);

	                    if (imgContainer.find('.tile-image-alt img').length > 0) {
	                        imgContainer.find('.tile-image-alt img').attr('src', swatchAltImg);
	                        imgContainer.find('.tile-image-alt source').attr('srcset', swatchAltImg);
	                    }
	                    imgLink.attr('href', swatchImgUrl);
	                    quickLink.attr('data-href', quickImgUrl);
	                }
	            }

	            let $tileBody = $(this).closest('.tile-body');

	            $tileBody.find('.swatch-circle').removeClass('selected');
	            $(this).addClass('selected');

	            var $promoContainer = $(this).closest('.product').find('.product-promo');

	            // Show conditional text for colors that are on clearance/sale/limitedEdition
	            var text = null;
	            var discountFlag = true; // to be used for sale/clearance discount class

	            // Update price on hover
	            // ajax call - color value & data-pid as input > backend controller - get variation model > color variants > get price model > range and price
	            var url = $('.tilePriceUrl').length ? $('.tilePriceUrl').val() : '';
	            var color = $swatch.attr('data-swatchid');
	            var colorVal = $swatch.attr('data-swatchvalue');
	            var pid = $(this).parents('.product').length ? $(this).parents('.product').attr('data-pid') : '';

	            // Show color name on swatch hover
	            var $colorName = $(this).parents('.tile-body').find('.color-name');
	            // Solid color names have three-letter code at the beginning of the name, prints do not.
	            var colorName = (color !== colorVal && color.toLowerCase().indexOf(colorVal) === 0) ? color.toUpperCase().substring(4) : color;
	            $colorName.text(colorName);

	            // find price container for the tile
	            var $priceContainer = $(this).parents('.tile-body').find('.tile-price-container');

	            if (url.length && pid.length) {
	                $.ajax({
	                    url: url,
	                    data: {
	                        color: color,
	                        colorVal: colorVal,
	                        pid: pid
	                    },
	                    method: 'GET',
	                    success: function (response) {
	                        if (response.success) {
	                            // Update price view
	                            // Remove price div and add new price
	                            var price = response.price;

	                            var $priceEle = $priceContainer.find('.price');
	                            $priceEle.remove();

	                            $('<div>').attr({
                                    class: 'price',
                                    'data-alt-price-title': 'Price:'
                                }).prependTo($priceContainer);
	                            $('<div>').attr({
                                    class: 'confirmation-modal-price',
                                }).appendTo($priceContainer.find('.price'));

	                            if (price.listPrice > price.salesPrice) {
	                                // Sales price with strike
	                                $('<span>').attr({
	                                    class: 'sales',
	                                }).text(price.salesPriceFormatted).appendTo($priceContainer.find('.confirmation-modal-price')).after('\n');
                                  $('<span>').attr({
                                    class: 'sr-only',
                                  }).text('price reduced from').appendTo($priceContainer.find('.confirmation-modal-price')).after('\n');
	                                $('<span>').attr({
	                                    class: 'list strike-through',
	                                }).text(price.listPriceFormatted).appendTo($priceContainer.find('.confirmation-modal-price'));
	                            } else {
	                                // Regular price
	                                $('<span>').attr({
	                                    class: 'list',
	                                }).text(price.listPriceFormatted).appendTo($priceContainer.find('.confirmation-modal-price'));
	                            }
	                            var promos = response.promoMessage;
	                            text = response.statusText.statusLabel;
	                            discountFlag = response.statusText.status != 'isSpecialOffer' ? true : false;
	                            if (promos.length > 0) {
		                            if ($tileBody.find('.product-promo').length > 0) {
		                            	$tileBody.find('.product-promo').html('');
		                            } else {
		                            	$('<ul></ul>').addClass('product-promo').appendTo($tileBody.find('.tile-price-container'));
		                        	}
		                            $tileBody.find('.status-label').html('');
		                        	$.each(promos, function(index){
		                        		$tileBody.find('.product-promo').append('<li class="product-features__item icon--none">' + promos[index].message + '</li>')
		                        	});
	                            } else {
	                            	var statusClass = discountFlag ? 'sales' : '';
	                            	$tileBody.find('.product-promo').html('');
	                            	$tileBody.find('.status-label').removeClass('sales').addClass(statusClass).html(text);
	                            }
	                        } else if (response.error) {
	                            console.log(response.errorMessage);
	                            return;
	                        }
	                    },
	                    error: function () {
	                        console.log('error while updating price on swatch hover');
	                        return;
	                    },
	                });
	            }
	        }
	    );
  }
};